import * as r from "react";
import { d as t } from "../defaultTheme-9f1e13f4.js";
import { T as e } from "../identifier-2b569a98.js";
import { u as m } from "../useTheme-89580aa5.js";
import "../createTheme-ef7fa3a1.js";
import "../objectWithoutPropertiesLoose-1e2b28af.js";
import "../_commonjsHelpers-c5d32002.js";
import "../extends-e3d0fd9d.js";
import "../extends-0a3e0827.js";
import "../index-057d60ee.js";
import "../useThemeWithoutDefault-9240f28c.js";
import "@emotion/react";
function E() {
  const o = m(t);
  return process.env.NODE_ENV !== "production" && r.useDebugValue(o), o[e] || o;
}
export {
  E as default,
  E as useTheme
};
//# sourceMappingURL=useTheme.js.map
